
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.36873 7.70611C5.67945 8.09796 6.32055 8.09796 6.63127 7.70611L11.8514 1.12314C12.223 0.654557 11.8551 3.07332e-07 11.2201 3.07332e-07H0.779882C0.144931 3.07332e-07 -0.22297 0.654557 0.148608 1.12314L5.36873 7.70611Z","fill":"#DD3B3B"}})])
          )
        }
      }
    